import React from 'react';
import { CloseButton } from 'src/components/Buttons';
import {
  CloseBtnContainer,
  Header,
  MvpDesignHeader,
  MvpNewDesignTitleContainer,
  TitleContainer,
} from './ModalHeader.styles';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

interface IModalHeader {
  title?: string | JSX.Element;
  onClick?: () => void;
  isSuccessDialog?: boolean;
}

const ModalHeader = ({ isSuccessDialog, title, onClick }: IModalHeader) => {
  const isFromMvpApp = useUrlParameterCheck('/app');
  const emoji = <span style={{ padding: '0 6px' }}>&#x1F60A;</span>;

  return isFromMvpApp ? (
    <MvpDesignHeader>
      <MvpNewDesignTitleContainer>
        {title}
        {isSuccessDialog && emoji}
      </MvpNewDesignTitleContainer>
    </MvpDesignHeader>
  ) : (
    <Header>
      <TitleContainer>{title}</TitleContainer>
      <CloseBtnContainer>
        <CloseButton onClick={onClick} color={'darkBlue'} />
      </CloseBtnContainer>
    </Header>
  );
};

export default ModalHeader;
